/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal, Slobodan Djordjevic
 */

let defaultValue = {
    loading: false,
    complete: false,
    error: null,
    value: null,
}

const loadACL = () => {
    return async (dispatch, getState) => {
        let acl = getState().acl
        let team = getState().team
        let user = getState().user
        let teamName = team.value ? team.value.name : "--"
        let userId = user.value ? user.value.user_id : -1
        let aclName = acl.value ? acl.value.team : "--"
        let token = getState().token?.value

        if (!token) {
            return { type: "NOOP" }
        }
        if (acl.loading || team.loading || user.loading) {
            return { type: "NOOP" }
        }
        if (
            acl.complete &&
            teamName === aclName &&
            userId === acl.value?.userId
        ) {
            return { type: "NOOP" }
        }

        dispatch({
            type: "COMMON_SET",
            key: "acl",
            value: { loading: true, error: null },
            defaultValue: { ...defaultValue },
        })

        let url = `https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/go/acl?user=${userId}`

        if (team.value) {
            url += `&team=${team.value.name}&team_id=${team.value.team_id}`
        }
        url += `&token=${token.token}&token_timestamp=${token.timestamp}`

        fetch(url, { method: "GET", mode: "cors" })
            .then((resp) => {
                return resp.json()
            })
            .then((json) => {
                dispatch({
                    type: "COMMON_SET",
                    key: "acl",
                    value: {
                        loading: false,
                        complete: true,
                        value: {
                            ...json.data,
                            team: teamName,
                            userId: userId,
                        },
                        error: json.error,
                    },
                    defaultValue: { ...defaultValue },
                })
            })
            .catch((e) => {
                console.warn(e)
            })
    }
}

export default loadACL
